import { Dropdown, Grid, Icon, Popup } from 'semantic-ui-react';
import React, { useContext } from 'react';
import { Contact, LinkedAccount, USER_PERMISSIONS } from 'dyl-components';
import { PhoneUtil, StringUtils } from 'utils';
import { Link } from 'react-router-dom';

import InfluenceField from './InfluenceField';

import { ContactContext } from 'shared/context/ContactProvider';
import { useSelector } from 'react-redux';
import { ActivityPopup } from 'shared/forms/NewActivity';
import TextIcon from 'shared/TextIcon';
import RestrictedView from 'shared/RestrictedView';

export default function AccountContact({
    contact,
    contactBeingEdited,
    account_id,
    onCancelEdit,
    contactColumnWidth,
    onUnpin,
    isSidePanelOpen,
    pinOptions,
    onReplacePinnedContact,
    isReadingContactsForPinning,
    onEdit,
    onClickToDial,
    onText,
    assignees,
}) {
    const { first_name, last_name, id, influence, module_summary, primary_phone, primary_email, job_title = '' } = contact;
    const name = `${first_name} ${last_name}`;

    const { userPhoneCreds, hasEmailIntegrations } = useSelector(state => ({
        userPhoneCreds: state?.officeView?.creds,
        hasEmailIntegrations: state.oauth_integrations?.integrations?.length > 0
    }));

    const isPhoneSystemSupported = PhoneUtil.isPhoneSystemSupported(userPhoneCreds);

    const { onOpenModal } = useContext(ContactContext);


    return (
        <Grid.Row key={id} verticalAlign='middle' columns='equal'>
            <Grid.Column verticalAlign='middle' width={contactColumnWidth}>
                    <Contact
                        leftSideContent={
                            <>
                                <Popup
                                    trigger={<Icon onClick={() => { onUnpin(id); }} color='primary' link className='fas thumbtack' />}
                                    content='Unpin'
                                    inverted />
                                <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.ACCOUNT_EDIT} userRestrict assignmentIds={[(assignees?.owner_id || 0), (assignees?.coowner_id || 0)]}>
                                    <Dropdown
                                        placeholder='Pin a Contact'
                                        selectOnBlur={false}
                                        selection
                                        options={pinOptions}
                                        value={id}
                                        onChange={(_, { value: contact_id }) => {
                                            if (contact_id) {
                                                if (contact_id !== id) {
                                                    onReplacePinnedContact(id, contact_id);
                                                }
                                            } else {
                                                onUnpin(id);
                                            }
                                        }}
                                        compact
                                        text={(
                                            <LinkedAccount
                                                account={name}
                                                maxWidth={'8.25em'}
                                                subtitle={job_title}
                                                popup
                                                linkToAccount={
                                                <RestrictedView type="link" userPermission={USER_PERMISSIONS.CONTACTS_VIEW} userRestrict assignmentIds={[(contact?.owner_id || 0), (contact?.coowner_id || 0)]}>
                                                    <Link onClick={e => { e.stopPropagation(); }} target={'_blank'} to={`/contact/${id}`}>{name}</Link>
                                                </RestrictedView>
                                                } 
                                            />
                                        )}
                                        clearable
                                        style={{ width: '15em' }}
                                        loading={isReadingContactsForPinning} />
                                </RestrictedView>
                            </>
                        }
                        isFixedWidth={false}
                        phone={primary_phone?.duplicate_contact_id ? undefined : primary_phone?.phone}
                        email={primary_email?.duplicate_contact_id ? undefined : primary_email?.email}
                        account_id={account_id}
                        contact_id={id}
                        isPhoneSystemSupported= {!!primary_phone?.duplicate_contact_id || isPhoneSystemSupported}
                        hasEmailIntegrations={hasEmailIntegrations}
                        onCallClick={() => onClickToDial(contact)}
                        onTextClick={onText}
                        onEmailClick={() => onOpenModal('email', id)}
                        onNoteClick={() => onOpenModal('note', contact)}
                        ActivityPopup={ActivityPopup}
                        TextIcon={TextIcon}
                        callActivityProps={{
                            hideActivitySelection: true,
                            contact: { id: contact?.id },
                            isContact: true
                        }}
                        emailActivityProps={{
                            readTimeline: () => { },
                            contact,
                            isContact: true,
                            emailOnly: true
                        }}
                        callSuspended={primary_phone?.call_suspended}
                    />
            </Grid.Column>
            <Grid.Column>
                <InfluenceField
                    account_id={account_id}
                    contactBeingEdited={contactBeingEdited}
                    id={id}
                    influence={influence}
                    onCancelEdit={onCancelEdit}
                    onEdit={onEdit}
                    recordType="account"
                    assignees={assignees}
                />
            </Grid.Column>
            <Grid.Column>
                {module_summary ? `${StringUtils.capitalize(module_summary.account_stage)}-${module_summary.pipeline_stage_name}` : ''}
            </Grid.Column>
        </Grid.Row>
    );
}

